import React, { useState, useEffect } from "react";
import Feature_collections_carousel from "../carousel/Feature_collection_carousel";
import Image from "next/image";
import { useInView } from "react-intersection-observer";
import  SecondDescripton  from "../common/SecondDescripton";
import Link from "next/link";

const Feature_collections = ({ bgWhite = false }) => {

const originalText =
    "Create, contribute to or support impactful campaigns. Build an impact portfolio that showcases what matters to you. Include impact art in gaming experiences to increase your fundraising engagement and outcomes.";

  const [isVisible, setIsVisible] = useState(false);
  const { ref, inView } = useInView({
    triggerOnce: true, // Only trigger once
    threshold: 0.5, // 50% of the target element is visible
  });

  useEffect(() => {
    if (inView) {
      setIsVisible(true);
    } else {
      setIsVisible(false); // Reset isVisible state when out of view
    }
  }, [inView]);
  return (
    <div className="py-24">
      <div
        ref={ref}
        className={`mx-auto mb-4 text-center px-2 ${isVisible ? "slide-in-left" : ""
          }`}
      >
        <h2 className="font-display text-3xl text-jacarta-700 dark:text-white lg:text-4xl xl:text-6xl text-center uppercase">
          IMPACT ART <span className="animate-gradient"> CAMPAIGN SHOWCASE</span>
        </h2>
        <SecondDescripton text={originalText}></SecondDescripton>
      </div>
      <section className="py-24 pt-5 relative max-sm:pb-5">
        {bgWhite && (
          <picture className="pointer-events-none absolute inset-0 -z-10 dark:hidden !ml-0">
            <Image
              src="/images/gradient_light.jpg"
              alt="gradient"
              className="h-full"
              width={800}
              height={800}
            />
          </picture>
        )}
        <div className="container">
          {/* <HeadLine
            // image="https://cdn.jsdelivr.net/npm/emoji-datasource-apple@7.0.2/img/apple/64/1f4a5.png"
            text="PROJECTS SPOTLIGHT"
            classes="font-display text-3xl text-jacarta-700 dark:text-white lg:text-4xl xl:text-6xl text-center uppercase"
          /> */}
          <div className="relative">
            <Feature_collections_carousel />
          </div>
        </div>
        <div className="mt-10 text-center">
          <Link
            href="/art-for-impact-campaign"
            className="uppercase bg-accent shadow-accent-volume hover:bg-accent-dark inline-block rounded-full py-3 px-8 text-center font-semibold text-white transition-all"
          >
            FIND OUT MORE
          </Link>
          <Link
            href="https://impactdots.world/"
            className="uppercase max-sm:ml-1 ml-5  max-sm:mt-4 bg-accent shadow-accent-volume hover:bg-accent-dark inline-block rounded-full py-3 px-8 text-center font-semibold text-white transition-all"
          >
            GO TO ART FOR IMPACT
          </Link>
        </div>
        {/* <Collection_category bgWhite={true} /> */}
      </section>
    </div>
  );
};

export default Feature_collections;
